export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby wybrać, które kolumny mają być wyświetlane"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyświetlane kolumny"])}
}